<template>

  <div class="wardrobes">

    <div class="wardrobe" v-if="builder.quoteAlert.length">
      <div class="wardrobe-inner">

        <div class="quotenotice">
          <div class="quotenotice-icon">
            <svg class="icon"><use href="#alarm"></use></svg>
          </div>
          <div class="quotenotice-text" v-html="builder.quoteAlert"></div>
        </div>

      </div>
    </div>

    <div class="wardrobe" v-for="(item, index) in builder.items" :key="index + 1">
      <div class="wardrobe-inner">

        <div class="wardrobe-header l_controllable">
          <div class="wardrobe-title">
            <strong v-if="item.label && item.label.length">{{ item.label }}</strong>
            <strong v-else-if="builder.isKlBuilder">{{ builder.firstNamePossesive }} {{ builder.currentProductTitle }}</strong>
            <strong v-else>{{ builder.range.itemName }} {{ index + 1 }}</strong>
            <span v-if="item.product && builder.isWardrobeBuilder" v-html="item.product.title"></span>
            <!-- <span v-else-if="item.productLayout && builder.isKlBuilder" v-html="item.productLayout.title"></span> -->
          </div>
          <div class="wardrobe-actions">

            <template v-if="builder.isWardrobeBuilder || builder.testMode || builder.isCp">

              <button class="button-circle l_grey" @click.stop="itemDelete($event, item.id)" v-if="builder.items.length > 1 && !builder.quote.ordered">
                <svg class="icon"><use xlink:href="#cross"></use></svg>
              </button>

              <button class="button-circle l_expand" @click.stop="itemEdit($event, item.id)" v-if="builder.quote.isEditable">
                <span class="button-circletext">Edit</span>
                <svg class="icon"><use xlink:href="#pencil"></use></svg>
              </button>

            </template>

            <template v-else-if="builder.isKlBuilder">

              <span v-html="builder.refShort"></span>

              <img src="/images/mydiy-logo.svg" alt="myDIY" height="30" style="margin-left: 20px;" data-hide="narrow">

            </template>

          </div>
        </div>

        <component
          :is="getComponent(item)"
          :item="item"
          v-if="item.valid"
          @lightbox-activate="lightboxActivate">
        </component>

        <div class="wardrobe-main l_specs" v-if="!item.valid">

          <div class="wardrobe-specs">

            <div class="wardrobe-spec l_w60">
              <div class="wardrobe-spec-inner">
                <p class="wardrobe-spec-title">Incomplete</p>
                <p class="wardrobe-spec-text">
                  Please edit this <span v-html="builder.range.itemName" style="text-transform: lowercase;"></span> to see the details and price.
                </p>
              </div>
            </div>

          </div>

        </div>

        <div class="wardrobe-footer">
          <div class="wardrobe-price" v-if="item.valid && (builder.items.length > 1 || builder.quoteNeedsSubtotal)">
            <span class="wardrobe-price-val" v-if="builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(item.total)"></span>
            <!-- <span class="wardrobe-price-inc">Inc. GST</span> -->
          </div>
          <div class="wardrobe-price" v-if="!item.valid">
            <span class="wardrobe-price-val"><span v-html="builder.range.itemName"></span> incomplete</span>
          </div>
        </div>

      </div>
    </div>

    <template v-if="!builder.quote.ordered && (!builder.quote.isCustom || builder.isCp) && builder.range.handle == 'wardrobes'">

      <div class="wardrobe" v-if="builder.canAddMoreItems">
        <button class="wardrobesaddbtn" @click.stop="itemCreate($event)">
          <div class="wardrobesaddbtn-title">Add another <span v-html="builder.range.itemName" style="text-transform: lowercase;"></span></div>
          <div class="button-circle l_child">
            <svg class="icon"><use xlink:href="#plus"></use></svg>
          </div>
        </button>
      </div>

      <div class="wardrobenotice l_light" v-else>
        <div class="wardrobenotice-inner">
          Maximum <span v-html="builder.range.itemName" style="text-transform: lowercase;"></span> limit for quote reached
        </div>
      </div>

    </template>

  </div>

  <Delivery></Delivery>

  <Adjusters></Adjusters>

  <PromoCode></PromoCode>

  <Totals></Totals>

</template>

<script setup>
import { ref, onMounted } from 'vue'

var _ = require('lodash');

const props = defineProps([
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

import Adjusters from "@/components/builder/quote/Adjusters.vue";
import Totals from "@/components/builder/quote/Totals.vue";
import Delivery from "@/components/builder/quote/Delivery.vue";
import PromoCode from "@/components/builder/quote/PromoCode.vue";

import Sliding from "@/components/builder/products/wardrobes/sliding/Quote.vue";
import Walkin from "@/components/builder/products/wardrobes/walkin/Quote.vue";
import Sliding2 from "@/components/builder/products/wardrobes/sliding2/Quote.vue";
import Hinged from "@/components/builder/products/wardrobes/hinged/Quote.vue";
import Kitchen from "@/components/builder/products/kitchens/kitchen/Quote.vue";
import CustomKitchen from "@/components/builder/products/custom/Quote.vue";
import Laundry from "@/components/builder/products/laundries/laundry/Quote.vue";
import CustomLaundry from "@/components/builder/products/custom/Quote.vue";
import CustomWardrobe from "@/components/builder/products/custom/Quote.vue";
import Custom from "@/components/builder/products/custom/Quote.vue";

const comps = {
  Sliding,
  Walkin,
  Sliding2,
  Hinged,
  Kitchen,
  CustomKitchen,
  Laundry,
  CustomLaundry,
  CustomWardrobe,
  Custom
};

function getComponent(item) {

  if (item.product) {
    return comps[item.product.handleCapitalised];
  }
  return false;
}

function itemEdit(e, itemId) {

  let submitData = {
    itemId: itemId
  };
  builder.actionPost('item/edit', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.setItemId(response.item.id);
      builder.validateCurrentItem();
      builder.setMode('build');
      builder.setStep(response.item.product.steps);
    }
  });

  // e.preventDefault();
  // return false;

}

function itemDelete(e, itemId) {

  if (confirm('Are you sure you want to remove this item from your quote?')) {

    let submitData = {
      itemId: itemId
    };
    builder.actionPost('item/delete', submitData).then(response => {
      if (_.isObject(response)) {
        builder.$patch((state) => {
          state.quote = response.quote;
        })
        builder.$patch((state) => {
          state.items = response.quote.items;
        })
        builder.setItemId(response.item.id);
        builder.setMode('quote');
      }
    });

  }

}

function itemCreate(e, itemId) {

  let submitData = {};
  builder.actionPost('item/create', submitData).then(response => {
    if (_.isObject(response)) {
      builder.$patch((state) => {
        state.quote = response.quote;
      })
      builder.items.push(response.item);
      builder.setItemId(response.item.id);
      builder.validateCurrentItem();
      builder.setMode('build');
      builder.setStep(1);
    }
  });

}

function lightboxActivate(dataSpec, handle) {

  let gallery = '';
  let description = '';
  let imageClass = '';
  if (handle == 'interior') imageClass = 'interior-image';

  if (['panel1', 'panel2', 'panel3', 'panel4'].indexOf(handle) !== -1) {

      let i = parseFloat(handle.replace(/^\D+/g, ''));

      if (!_.isUndefined(dataSpec.group) && _.isObject(dataSpec.group)) description += '<strong>' + dataSpec.group.title + ' ' + i + ':</strong> ';
      description += dataSpec.title;
      gallery = [];
      if (dataSpec.gallery.length) gallery = generateGallery(dataSpec.gallery);
      gallery.push({
        id: gallery.length + 1,
        content: '<img src="' + dataSpec.image + '" alt="" class="' + imageClass + '">'
      });

  } else {

    if (!_.isUndefined(dataSpec.group) && _.isObject(dataSpec.group)) description += '<strong>' + dataSpec.group.title + ':</strong> ';
    description += dataSpec.title;
    gallery = [];
    if (dataSpec.gallery.length) gallery = generateGallery(dataSpec.gallery);
    gallery.push({
      id: gallery.length + 1,
      content: '<img src="' + dataSpec.image + '" alt="" class="' + imageClass + '">'
    });


  }

  if (description.length) description = '<p style="text-align: center;">' + description + '</p>';

  lightbox.open(description, gallery);

  return false;

}

function generateGallery(galleryArray) {
  let gallery = [];
  for (let i = 0; i < galleryArray.length; i ++) {
    gallery.push({
      id: i + 1,
      content: '<img src="' + galleryArray[i] + '" alt="">'
    });
  }
  return gallery;
}


</script>
